import type { OfferLocaleOverrides } from '../base';
import { sellersAttorneyContactCard } from '../cards';

export const NJOverrides: OfferLocaleOverrides = {
  locale: 'NJ',
  sections: {
    propertyInfo: {
      cards: {
        propertyBeingSoldCard: {
          layout: (layout) =>
            layout.concat([
              [
                {
                  name: 'property.lot',
                  size: 50,
                },
                {
                  name: 'property.block',
                  size: 50,
                },
              ],
            ]),
          fields: {
            lot: {
              name: 'property.lot',
              entity: 'property',
              type: 'text',
              label: 'Lot',
              placeholderText: '',
              validation: [
                {
                  type: 'required',
                  message: 'Required',
                },
              ],
            },
            block: {
              name: 'property.block',
              entity: 'property',
              type: 'text',
              label: 'Block',
              placeholderText: '',
              validation: [
                {
                  type: 'required',
                  message: 'Required',
                },
              ],
            },
          },
        },
        emdCard: {
          fields: {
            numbersDaysEmdDue: null,
          },
        },
      },
    },
    sellerSideContacts: {
      cards: {
        sellersAttorneyContactCard,
      },
    },
    additionalContacts: {
      cards: {
        titleOfficerContactCard: {
          order: 2,
        },
        addAdditionalContactCard: {
          fields: {
            newContact: {
              options: () => [
                {
                  label: 'Appraiser',
                  value: 'additionalContacts.appraiser',
                },
                {
                  label: 'Home Warranty',
                  value: 'additionalContacts.homeWarranty',
                },
                {
                  label: 'Other',
                  value: 'additionalContacts.other',
                },
              ],
            },
          },
        },
      },
    },
  },
};
